module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-CF.563901b2.png";